import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { storefrontShortcutsBarAdminRouter } from './routing/storefrontShortcutsBarRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'storefront-shortcuts-bar',
  totem: {
    tool: 'shortcuts-bar-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
  },
  routers: {
    admin: [storefrontShortcutsBarAdminRouter],
  },
  adminNavigationEntries: [],
  navigationEntries: [],
}

export default definition
